<template>
  <jw-table class="common-table" v-bind="attrs" sticky-header :data="props.data" v-if="props.data?.length" default-expand-all-rows row-key="dataType" max-height="600px" :bordered="false" :pagination="false">
    <template #expand-icon="{ expanded }">
      <icon-caret-down v-if="expanded" />
      <icon-caret-right v-else />
    </template>
    <template #moduleName="{ record }">
      {{ record.type === 'module' ? record.moduleName : record.dataItem }}
    </template>
    <template #status="{ record }">
      <status-tag :status="record.status" />
    </template>
    <template #failReason="{ record }">
      <fh-ellipsis :style="{ width: '100%' }" :content="record.failReason" />
    </template>
    <template #progress="{ record }">
      <template v-if="record?.type !== 'module'">
        <jw-progress :color="record.status === TaskStatusEnum.FAILURE ? 'rgb(var(--danger-6))' : 'rgb(var(--primary-6))'" :percent="(record.progress || 0) / 100" />
      </template>
    </template>
    <template #importResult="{ record }">
      <template v-if="record?.type !== 'module'">
        <template v-if="[TaskStatusEnum.DOING, TaskStatusEnum.DONE].includes(record.status)"> {{ `${record.sourceCount || 0}` }}/{{ `${record.finishCount || 0}` }}</template>
        <span class="empty-text" v-else>-</span>
      </template>
    </template>
    <!-- <template #operation="{ record }" v-if="record?.type !== 'module'">
      <template>
        <slot name="operation" v-bind="{ record }"></slot>
      </template>
    </template> -->
    <template #operation="{ record }">
      <template v-if="props.type === 1">
        <!-- exportEnable 允许重新导出 -->
        <jw-link v-if="record.exportEnable && [TaskStatusEnum.DONE, TaskStatusEnum.ERROR].includes(record.status)" @click="handleExportItem(record)">重新导出</jw-link>
      </template>
      <template v-if="props.type === 2">
        <jw-popover trigger="click" class="depndencies-popover">
          <jw-link v-if="[TaskStatusEnum.NEW, TaskStatusEnum.ERROR].includes(record.status)">前置校验</jw-link>
          <template #content>
            <div v-if="record.dependencies?.length">
              <p class="depndencies-item" :key="item.dataType" v-for="item in getDependenciesData(record.dependencies)" :type="item.status === TaskStatusEnum.DONE ? 'success' : 'error'">
                <span>
                  <icon-check-circle-fill v-if="item.status === TaskStatusEnum.DONE" style="color: rgb(var(--success-6)); font-size: 18px" />
                  <icon-close-circle-fill v-else style="color: rgb(var(--danger-6)); font-size: 18px" />
                </span>
                {{ item.dataItem }}
              </p>
            </div>
            <div v-else>暂无</div>
          </template>
        </jw-popover>
        <jw-popconfirm :content-style="{ width: '280px' }" position="tr" @ok="handleImportItem(record)">
          <template #content>
            <p style="font-weight: bold">确定要重置状态吗？</p>
            <p>重置操作将恢复状态为「进行中」</p>
          </template>
          <jw-link v-if="[TaskStatusEnum.ERROR].includes(record.status)">重新导入</jw-link>
        </jw-popconfirm>
      </template>
    </template>
  </jw-table>
</template>

<script setup>
import { useAttrs, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useMigrationToolsStore } from '@/store';
import FhEllipsis from '@/components/fh-ellipsis/index.vue';
import StatusTag from '../status-tag/status-tag.vue';
import useActions from '../../hooks/useActions';
import { TaskStatusEnum } from '../../constant';

const attrs = useAttrs();
const props = defineProps({
  data: {
    type: Array,
    default: () => []
  },
  type: {
    type: Number,
    default: 0
  },
  entity: {
    type: String
  }
});

const currentStep = ref(props.type);
const currentEntity = ref(props.entity);
const migrationToolsStore = useMigrationToolsStore();
const { tableData } = storeToRefs(migrationToolsStore);
const { handleExportItem, handleImportItem } = useActions({ currentStep, dataEntity: currentEntity });
console.log('');
// 获取前置校验Data
const getDependenciesData = (dataTypeArr = []) => {
  return tableData.value?.filter((item) => dataTypeArr.includes(item.dataType));
};
</script>
<style scoped lang="less">
@import './common-table.less';
</style>
